import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { projectTaskGroupCreationService } from "../../../services/projectDetails";
import { useDispatch } from "react-redux";

export default function GroupModal({
  data,
  setModal,
  mileStoneId,
  renderer,
  setRenderer,
}) {
  const dispatch = useDispatch();
  const [groupTitle, setGroupTitle] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const DetailedProjectData = useSelector(
    (state) => state.projectDetails.getDetailedProjectData
  );

  const handleGroupCreation = async () => {
    setError("");
    if (!groupTitle.trim()) {
      setError("Group name is required!");
      return;
    }

    setLoading(true);

    try {
      const responseData = await projectTaskGroupCreationService({
        project_id: DetailedProjectData.project._id,
        milestone_id: mileStoneId,
        group_name: groupTitle,
      });

      if (responseData && responseData.status === 200) {
        toast.success(responseData?.data?.message);
        setRenderer(!renderer);
        setModal(false);
      } else {
        toast.error(responseData.message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (data) {
      setIsVisible(true);
    }
  }, [data]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      setModal(false);
    }, 250);
  };

  return (
    <div
      className="pd-theme relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`fixed inset-0 bg-theme-ink opacity-5 z-10`}
        onClick={() => handleClose()}
      />
      <div
        className={`fixed h-fit w-fit inset-0 top-40 z-20 left-1/2 ${
          isVisible ? " animate-slideIn" : "animate-slideOut"
        }`}
      >
        <div className="flex items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="relative transform overflow-hidden rounded-theme-xl bg-theme-paper text-left shadow-theme-pop transition-all min-w-[300px] sm:w-full sm:max-w-lg">
            <div className="bg-theme-paper p-6">
                <div className="flex justify-end">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    onClick={() => handleClose()}
                    stroke="currentColor"
                    className="w-6 h-6 cursor-pointer text-theme-fg-3"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </div>
                <div className="modal-body relative">
                  <label className="text-sm font-semibold text-theme-fg-2">Group Name <span className="text-theme-full-fg">*</span></label>
                  <input
                    className={`p-3 w-full text-sm outline-none rounded-theme-sm border text-theme-fg-1 mt-1 ${
                      error ? 'border-theme-full-fg ring-2 ring-theme-full-fg/20 mb-1' : 'border-theme-cream-3 mb-5'
                    }`}
                    type="text"
                    placeholder="Enter Group name"
                    value={groupTitle}
                    onChange={(e) => {
                      setError("");
                      setGroupTitle(e.target.value);
                    }}
                  />
                  {error && (
                    <p className="text-xs text-theme-full-fg font-semibold mb-4 mt-0.5">{error}</p>
                  )}

                  <button
                    onClick={handleGroupCreation}
                    disabled={loading}
                    className={`mb-4 p-3 px-5 w-full ${
                      loading
                        ? "bg-theme-cream-3 cursor-not-allowed"
                        : "bg-theme-ink hover:bg-theme-ink-2"
                    } text-sm text-white font-semibold rounded-theme-sm flex justify-center`}
                  >
                    {loading ? (
                      <div className="w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin "></div>
                    ) : (
                      "Create Group"
                    )}
                  </button>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  );
}
